import { render, staticRenderFns } from "./officeCollection.vue?vue&type=template&id=4de25d95&scoped=true&"
import script from "./officeCollection.vue?vue&type=script&lang=js&"
export * from "./officeCollection.vue?vue&type=script&lang=js&"
import style0 from "./officeCollection.vue?vue&type=style&index=0&id=4de25d95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de25d95",
  null
  
)

export default component.exports